import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import LockedTimesheetRenderer from 'timeSheet/components/CellRenderers/LockedTimesheetRenderer';

const useLockedTimesheetColumn = () => {
  const { t, isRtl } = useContext(ConfigContext);

  const cellRenderer = useCallback((params) => {
    if (params.node?.group) return null;
    return LockedTimesheetRenderer({ rowData: params.data });
  }, []);

  return useMemo(
    () => ({
      field: 'isLocked',
      headerName: t('timesheetLocked'),
      pinned: isRtl ? 'right' : 'left',
      width: 135,
      resizable: false,
      sortable: false,
      initialHide: true,
      cellClass: 'justify-center',
      cellRenderer
    }),
    [t, cellRenderer, isRtl]
  );
};

export default useLockedTimesheetColumn;
